import {Swiper, Navigation} from 'swiper';

jQuery(document).ready(function ($) {
    Swiper.use(Navigation)
    let dealersSlider = new Swiper('.swiper-container.dealers__slider', {
        loop: false,
        spaceBetween: 12,
        slidesPerView: 'auto',
        simulateTouch: true,
        freeMode: false,
        watchOverflow: true,
        grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'swiper-button-disabled',
        },
        breakpoints: {
            768: {
                spaceBetween: 32,
            }
        }
    });
    let reviewsSlider = new Swiper('.swiper-container.reviews__slider', {
        loop: false,
        spaceBetween: 32,
        slidesPerView: 'auto',
        simulateTouch: true,
        freeMode: false,
        watchOverflow: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: 'swiper-button-disabled',
        },
    });
    let relatedPostsSlider = new Swiper('.related-posts__bottom', {
        loop: false,
        spaceBetween: 25,
        slidesPerView: 'auto',
        simulateTouch: true,
        freeMode: false,
        watchOverflow: true,
    });

    $('.swiper-container.collection__slider').each(function () {
        let swiperID = $(this).data('swiper-id');
        let slideCount = $(this).data('slide-count');

        if (slideCount <= 1) {
            // If there's only one slide, disable Swiper functionality
            $(this).find('.swiper-button-next, .swiper-button-prev').hide();
            return;
        }

        let collectionSwiper = new Swiper(this, {
            loop: false,
            spaceBetween: 12,
            slidesPerView: 'auto',
            simulateTouch: true,
            freeMode: false,
            watchOverflow: true,
            navigation: {
                nextEl: '#next-' + swiperID,
                prevEl: '#prev-' + swiperID,
                disabledClass: 'swiper-button-disabled',
            },
            breakpoints: {
                768: {
                    spaceBetween: 32,
                }
            }
        });

        const swiper = this.swiper;

        $(this).parents('.dealer-collection__inner-wrapper').find('.swiper-button-prev').on('click', function (e) {
            e.preventDefault();
            collectionSwiper.slidePrev();
        });

        $(this).parents('.dealer-collection__inner-wrapper').find('.swiper-button-next').on('click', function (e) {
            e.preventDefault();
            collectionSwiper.slideNext();
        });
    });

    const handleResize = () => {
        if (window.innerWidth <= 576) {
            if (relatedPostsSlider) {
                relatedPostsSlider.destroy(true, true);
            }
        }
    };

    handleResize();

    window.addEventListener('resize', handleResize);
});
